import { isElement } from "@courses-pm2/api/src/ts/utils";

/**
 * Helper that'll extract all direct children by the given tag name from the
 * node.
 */
export function getChildrenByTagName(node: Element, tagName: string): Element[] {
    const lowerCaseTagName = tagName.toLowerCase();
    const children: Element[] = [];

    node.childNodes.forEach((child) => {
        if (
            isElement(child) &&
            child.tagName.toLowerCase() === lowerCaseTagName
        ) {
            children.push(child);
        }
    });

    return children;
}
